import { Editor } from '@tinymce/tinymce-react';
import React, { ForwardedRef } from 'react';

type Props = {
  name: string;
  required?: boolean;
  value?: string;
  onChange: (value: string) => void;
};

const WysiwygEditorInput = React.forwardRef((props: Props, ref: ForwardedRef<any>) => {
  const { name, required = false, value, onChange } = props;

  const handleChange = (content: string, editor: any) => {
    onChange(content);
  };

  return (
    <Editor
      value={value}
      init={{
        height: 500,
        menubar: false,
        relative_urls: false,
        convert_urls: false,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor code',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
        ],
        toolbar: `undo redo | formatselect fontsizeselect | bold italic link forecolor backcolor | code |
                      alignleft aligncenter alignright alignjustify |
                      bullist numlist outdent indent | removeformat | help`,
      }}
      onEditorChange={handleChange}
      ref={ref}
    />
  );
});

export default WysiwygEditorInput;
